import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { PopoverTrigger } from '../../../../popover/patched-popover/PatchedPopover.mjs';

const SingleSelectTrigger = forwardRef((props, forwardedRef) => {
  return /* @__PURE__ */ jsx(
    PopoverTrigger,
    {
      "data-scope": "single-select",
      "data-part": "trigger",
      ref: forwardedRef,
      ...props
    }
  );
});

export { SingleSelectTrigger as SelectTrigger };
//# sourceMappingURL=Trigger.mjs.map
